var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "30px",
    viewBox: "0 0 19 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02.Icons / Basic / Line / Chervon / Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.0_Template_09-Copy-23",
    transform: "translate(-1211.000000, -473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(130.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Line-/-Chervon-/-Right",
    transform: "translate(1060.000000, 408.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "currentColor",
    points: "25 15 21.475 18.525 32.925 30 21.475 41.475 25 45 40 30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrowIcon);
export default __webpack_public_path__ + "static/media/NextArrowIcon.bf8df44c06618e89924b8d8c777edb32.svg";
export { ForwardRef as ReactComponent };